import { toString, Record, Union } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { int32_type, option_type, lambda_type, unit_type, record_type, class_type, string_type, union_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { join, substring, toText, replace, printf, toFail } from "../../fable_modules/fable-library.3.7.20/String.js";
import { S5PaymentError$reflection, CreateNewPaymentApiDTO, getAmount, PayState_GetPayState_2E0C21E3, CreateNewPaymentResponseApiDTO$reflection, CreateNewPaymentApiDTO$reflection, Invoice$reflection } from "./Model.js";
import { PeriodModule_toString, Period, PeriodModule_ofString, IsoCountryCode$reflection } from "../../DomainTypes.js";
import { Result_Bind, FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { CreateFeeDTOV2, CreateFeeDTOV2$reflection } from "../../Api/Fee.js";
import { CreateInvoiceNoteDTO, CreateDirectInvoiceDTO, InvoiceFeeDTO, CreateDirectInvoiceDTO$reflection, CreateInvoiceNoteDTO$reflection, DirectInvoiceInfo$reflection } from "../../Api/DirectInvoice.js";
import { abs, op_UnaryNegation, op_Addition, compare, op_Division, op_Multiply, equals, fromParts, round } from "../../fable_modules/fable-library.3.7.20/Decimal.js";
import Decimal from "../../fable_modules/fable-library.3.7.20/Decimal.js";
import { defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { DateOnlyExtensions_fromDateTime, logwi, loge, Result_toBool, stackClasses, decimalToTwoDecimals, parseDecimal } from "../../Utils.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { useSelector } from "../../Redux/Store.js";
import { SaveStatus, getTranslationFrom } from "../../Global.js";
import * as react from "react";
import { isEmpty, choose, map, singleton as singleton_1, sortByDescending, tryFind, ofArray, filter, sort, tryPick, empty } from "../../fable_modules/fable-library.3.7.20/List.js";
import { unEscape, separateByThousands } from "../../Utilities/String.js";
import { getVatRates } from "../../CommonData.js";
import { singleton } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { day as day_1, month as month_1, year as year_1, equals as equals_2, now as now_1 } from "../../fable_modules/fable-library.3.7.20/Date.js";
import { uncurry, comparePrimitives, equals as equals_1 } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { day, month, year, create } from "../../fable_modules/fable-library.3.7.20/DateOnly.js";
import { SelectOption, ValueProp as ValueProp_1, SelectOption_get_getDefault, selectOption, RadioInput, RadioInput_get_getDefault, inputRadio } from "../../Components/FormFields/FormFields.js";
import { Browser_Types_Event__Event_get_Value } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Extensions.fs.js";
import { error, MessageKind, customMessage } from "../../Components/Message/Message.js";
import { TextProps$1, TextProps$1_GetDefault, render as render_1 } from "../../Components/StatefulFormFields/Text.js";
import { isNotNullOrWhitespace, isOnlyNumberWithPossibleDecimals, InputType, lengthLTE } from "../../Validation/Common.js";
import { HTMLAttr } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { keyValueList } from "../../fable_modules/fable-library.3.7.20/MapUtil.js";
import { ButtonProps, ButtonProps_get_getDefault } from "../../Components/Button/Button.js";
import { startImmediate } from "../../fable_modules/fable-library.3.7.20/Async.js";
import { loge as loge_1 } from "../../Utils.js";
import { Auto_generateBoxedDecoder_79988AEF, fromString } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { CaseStrategy } from "../../fable_modules/Thoth.Json.10.2.0/Types.fs.js";
import { renderAsModalThenSaveState } from "../../Components/Modals/SaveState/SaveState.js";
import { ModalSize } from "../../Components/Modal/Modal.js";
import "../../../src/Containers/Invoices/Credit.scss";


export class ActionChoice extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["CreditViaDirectInvoice", "CreditNextInvoice", "Void", "CustomerLoss"];
    }
}

export function ActionChoice$reflection() {
    return union_type("Containers.Invoices.Credit.ActionChoice", [], ActionChoice, () => [[], [], [], []]);
}

export function ActionChoice_get_FromString() {
    return (_arg) => ((_arg === "CreditViaDirectInvoice") ? (new ActionChoice(0)) : ((_arg === "CreditNextInvoice") ? (new ActionChoice(1)) : ((_arg === "Void") ? (new ActionChoice(2)) : ((_arg === "CustomerLoss") ? (new ActionChoice(3)) : toFail(printf("Cannot parse \u0027%s\u0027 into CreditModalChoice."))(_arg)))));
}

export function ActionChoice_get_ToString() {
    return (_arg) => ((_arg.tag === 1) ? "CreditNextInvoice" : ((_arg.tag === 2) ? "Void" : ((_arg.tag === 3) ? "CustomerLoss" : "CreditViaDirectInvoice")));
}

class AmountChoice extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["RemainingAmount", "SpecificAmount"];
    }
}

function AmountChoice$reflection() {
    return union_type("Containers.Invoices.Credit.AmountChoice", [], AmountChoice, () => [[], []]);
}

function AmountChoice_get_ToString() {
    return (_arg) => ((_arg.tag === 1) ? "SpecificAmount" : "RemainingAmount");
}

function AmountChoice_get_FromString() {
    return (_arg) => ((_arg === "RemainingAmount") ? (new AmountChoice(0)) : ((_arg === "SpecificAmount") ? (new AmountChoice(1)) : toFail(printf("[PartialRadioChoice] Can\u0027t parse string: %s"))(_arg)));
}

class AmountMsg extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["ChangeAmountInclVat", "ChangeAmountExclVat", "ChangeVat"];
    }
}

function AmountMsg$reflection() {
    return union_type("Containers.Invoices.Credit.AmountMsg", [], AmountMsg, () => [[["Item", string_type]], [["Item", string_type]], [["Item", string_type]]]);
}

export class AmountState extends Record {
    constructor(AmountInclVat, AmountExclVat, Vat) {
        super();
        this.AmountInclVat = AmountInclVat;
        this.AmountExclVat = AmountExclVat;
        this.Vat = Vat;
    }
}

export function AmountState$reflection() {
    return record_type("Containers.Invoices.Credit.AmountState", [], AmountState, () => [["AmountInclVat", string_type], ["AmountExclVat", string_type], ["Vat", class_type("System.Decimal")]]);
}

export class CreditModalProps extends Record {
    constructor(CloseModalFn, DefaultSelectedRadio, AccountNoCrediting, Invoice, CountryCode, CreateNewPaymentFn, CreateInvoiceeFeeFn, LoadDirectInvoiceInfo, CreateInvoiceNote, CreateDirectInvoiceFn, ReloadPendingDirectInvoices) {
        super();
        this.CloseModalFn = CloseModalFn;
        this.DefaultSelectedRadio = DefaultSelectedRadio;
        this.AccountNoCrediting = (AccountNoCrediting | 0);
        this.Invoice = Invoice;
        this.CountryCode = CountryCode;
        this.CreateNewPaymentFn = CreateNewPaymentFn;
        this.CreateInvoiceeFeeFn = CreateInvoiceeFeeFn;
        this.LoadDirectInvoiceInfo = LoadDirectInvoiceInfo;
        this.CreateInvoiceNote = CreateInvoiceNote;
        this.CreateDirectInvoiceFn = CreateDirectInvoiceFn;
        this.ReloadPendingDirectInvoices = ReloadPendingDirectInvoices;
    }
}

export function CreditModalProps$reflection() {
    return record_type("Containers.Invoices.Credit.CreditModalProps", [], CreditModalProps, () => [["CloseModalFn", lambda_type(unit_type, unit_type)], ["DefaultSelectedRadio", option_type(ActionChoice$reflection())], ["AccountNoCrediting", int32_type], ["Invoice", Invoice$reflection()], ["CountryCode", IsoCountryCode$reflection()], ["CreateNewPaymentFn", lambda_type(CreateNewPaymentApiDTO$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [CreateNewPaymentResponseApiDTO$reflection(), string_type], FSharpResult$2, () => [[["ResultValue", CreateNewPaymentResponseApiDTO$reflection()]], [["ErrorValue", string_type]]])]))], ["CreateInvoiceeFeeFn", lambda_type(CreateFeeDTOV2$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [CreateFeeDTOV2$reflection(), string_type], FSharpResult$2, () => [[["ResultValue", CreateFeeDTOV2$reflection()]], [["ErrorValue", string_type]]])]))], ["LoadDirectInvoiceInfo", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [DirectInvoiceInfo$reflection(), string_type], FSharpResult$2, () => [[["ResultValue", DirectInvoiceInfo$reflection()]], [["ErrorValue", string_type]]])]))], ["CreateInvoiceNote", lambda_type(CreateInvoiceNoteDTO$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])]))], ["CreateDirectInvoiceFn", lambda_type(CreateDirectInvoiceDTO$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])]))], ["ReloadPendingDirectInvoices", lambda_type(unit_type, unit_type)]]);
}

export function roundToTwoDecimals(d) {
    return round(d, 2);
}

export function amountPrepareForParse(str) {
    let str_5;
    return defaultArg(parseDecimal((str_5 = replace(replace(str, ",", "."), "-", ""), str_5.trim())), fromParts(0, 0, 0, false, 0));
}

export const renderCreditModal = FunctionComponent_Of_Z5A158BBF((props) => {
    let arg_10, inputRecord, DisplayString, IsChecked, inputRecord_1, DisplayString_1, IsChecked_1, inputRecord_2, DisplayString_2, IsChecked_2, inputRecord_3, DisplayString_3, IsChecked_3, matchValue_10, inputRecord_4, LabelText, props_8, inputRecord_5, arg_31, arg_30, inputRecord_6, arg_34, arg_33, inputRecord_7, arg_35, inputRecord_8, LabelText_4, props_17, matchValue_15;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const noteState = react.useState("");
    const saveItems = react.useState(empty());
    const payState = PayState_GetPayState_2E0C21E3(props.Invoice);
    const amount = getAmount(props.Invoice);
    const remainingAmount_1 = (payState.tag === 1) ? payState.fields[0] : ((payState.tag === 2) ? payState.fields[0] : fromParts(0, 0, 0, false, 1));
    const remainingAmountStr = separateByThousands(decimalToTwoDecimals(remainingAmount_1));
    const vatRates = getVatRates(props.CountryCode);
    let feeDescriptionDefaultText;
    const arg = getTranslation("CustomerContract.Invoicee.Invoices.CreditingOfInvoice");
    feeDescriptionDefaultText = toText(printf("%s %i"))(arg)(props.Invoice.InvoiceNumber);
    let feeDescriptionPartialText;
    const arg_2 = getTranslation("CustomerContract.Invoicee.Invoices.CreditingOfInvoicePartial");
    feeDescriptionPartialText = toText(printf("%s %i"))(arg_2)(props.Invoice.InvoiceNumber);
    const feeDescriptionState = react.useState(feeDescriptionDefaultText);
    let amountState;
    let vat_2;
    const vat_1 = defaultArg(props.Invoice.Vat, fromParts(0, 0, 0, false, 0));
    const amountExVat_1 = defaultArg(props.Invoice.AmountExclVat, fromParts(0, 0, 0, false, 0));
    const aproxInvoiceVat = equals(amountExVat_1, fromParts(0, 0, 0, false, 0)) ? fromParts(25, 0, 0, false, 0) : round(op_Multiply(op_Division(vat_1, amountExVat_1), fromParts(100, 0, 0, false, 0)), 0);
    vat_2 = defaultArg(tryPick((arg_7) => arg_7, sort(filter((x) => (compare(x, aproxInvoiceVat) >= 0), vatRates), {
        Compare: compare,
    })), defaultArg(tryPick((arg_8) => arg_8, vatRates), fromParts(25, 0, 0, false, 0)));
    amountState = react.useReducer((state_1, msg) => {
        let s_1, s_1_1;
        const maybeUpdateFeeDescription = (amountInclVat) => {
            const isFullAmount = equals(amountInclVat, op_Addition(defaultArg(props.Invoice.AmountExclVat, fromParts(0, 0, 0, false, 1)), defaultArg(props.Invoice.Vat, fromParts(0, 0, 0, false, 1))));
            const matchValue = [((feeDescriptionState[0]) === feeDescriptionDefaultText) ? true : ((feeDescriptionState[0]) === feeDescriptionPartialText), isFullAmount];
            if (matchValue[0]) {
                if (matchValue[1]) {
                    feeDescriptionState[1](feeDescriptionDefaultText);
                }
                else {
                    feeDescriptionState[1](feeDescriptionPartialText);
                }
            }
        };
        switch (msg.tag) {
            case 1: {
                const amount_2 = msg.fields[0];
                const amountInclVat_2 = roundToTwoDecimals(op_Multiply(amountPrepareForParse(amount_2), op_Addition(new Decimal(1), op_Division(state_1.Vat, (s_1 = (new Decimal(0)), ((() => {
                    for (let i = 0; i <= (100 - 1); i++) {
                        s_1 = op_Addition(s_1, new Decimal(1));
                    }
                })(), s_1))))));
                maybeUpdateFeeDescription(amountInclVat_2);
                return new AmountState(toText(printf("%.02f"))(amountInclVat_2), amount_2, state_1.Vat);
            }
            case 2: {
                const matchValue_1 = parseDecimal(msg.fields[0]);
                if (matchValue_1 != null) {
                    const vatRate_1 = matchValue_1;
                    const amountInclVat_3 = op_Multiply(amountPrepareForParse(state_1.AmountExclVat), op_Addition(new Decimal(1), op_Division(vatRate_1, (s_1_1 = (new Decimal(0)), ((() => {
                        for (let i_1 = 0; i_1 <= (100 - 1); i_1++) {
                            s_1_1 = op_Addition(s_1_1, new Decimal(1));
                        }
                    })(), s_1_1)))));
                    return new AmountState(toText(printf("%.2f"))(amountInclVat_3), state_1.AmountExclVat, vatRate_1);
                }
                else {
                    return toFail(printf("| AmountMsg.ChangeVat - Cannot parse vatRate."));
                }
            }
            default: {
                const amount_1 = msg.fields[0];
                const amountInclVat_1 = amountPrepareForParse(amount_1);
                const amountExclVat = roundToTwoDecimals(op_Division(amountInclVat_1, op_Addition(fromParts(10, 0, 0, false, 1), op_Division(state_1.Vat, fromParts(1000, 0, 0, false, 1)))));
                maybeUpdateFeeDescription(amountInclVat_1);
                return new AmountState(amount_1, toText(printf("%.02f"))(amountExclVat), state_1.Vat);
            }
        }
    }, new AmountState(toText(printf("%.2f"))(remainingAmount_1), (arg_10 = op_Division(remainingAmount_1, op_Addition(fromParts(10, 0, 0, false, 1), op_Division(vat_2, fromParts(1000, 0, 0, false, 1)))), toText(printf("%.2f"))(arg_10)), vat_2));
    let actionChoiceState;
    let arg_11;
    const matchValue_2 = props.DefaultSelectedRadio;
    arg_11 = ((matchValue_2 == null) ? (new ActionChoice(1)) : matchValue_2);
    actionChoiceState = react.useState(arg_11);
    const errorMessageState = react.useState(void 0);
    const createOneTimeFeeAndMaybeDirectInvoice = (createFeeDTO, shouldCreateDirectInvoice) => {
        const saveOneTimeFeeMsg = getTranslation("CustomerContract.Invoicee.Invoices.CreateFeeForInvoice");
        const createDirectInvoiceMsg = getTranslation("CustomerContract.Invoicee.Invoices.CreateDirectInvoice");
        const createInvoiceNoteMsg = getTranslation("CustomerContract.Invoicee.Invoices.CreateInvoiceNote");
        if (shouldCreateDirectInvoice) {
            saveItems[1](ofArray([[saveOneTimeFeeMsg, new SaveStatus(1)], [createDirectInvoiceMsg, new SaveStatus(0)], [createInvoiceNoteMsg, new SaveStatus(0)]]));
            return singleton.Delay(() => singleton.Bind(props.CreateInvoiceeFeeFn(createFeeDTO), (_arg_3) => {
                const createFeeResult_1 = _arg_3;
                if (createFeeResult_1.tag === 0) {
                    saveItems[1](ofArray([[saveOneTimeFeeMsg, new SaveStatus(2)], [createDirectInvoiceMsg, new SaveStatus(1)], [createInvoiceNoteMsg, new SaveStatus(0)]]));
                    return singleton.Bind(props.LoadDirectInvoiceInfo(), (_arg_4) => {
                        const directInvoiceInfoResult = _arg_4;
                        if (directInvoiceInfoResult.tag === 0) {
                            const now = now_1();
                            const matchValue_5 = tryFind((fee_1) => {
                                if ((equals_1(PeriodModule_ofString(fee_1.Period), new Period(0)) && equals_2(create(year(fee_1.PeriodFrom), month(fee_1.PeriodFrom), day(fee_1.PeriodFrom)), create(year_1(now), month_1(now), day_1(now)))) && (fee_1.PeriodTo == null)) {
                                    return fee_1.Description === createFeeDTO.Description;
                                }
                                else {
                                    return false;
                                }
                            }, sortByDescending((fee) => fee.FeeNr, directInvoiceInfoResult.fields[0].Fees, {
                                Compare: comparePrimitives,
                            }));
                            if (matchValue_5 != null) {
                                const directInvoiceFee = matchValue_5;
                                const createDirectInvoiceDTO = new CreateDirectInvoiceDTO(true, true, void 0, false, 3, true, singleton_1(new InvoiceFeeDTO(directInvoiceFee.FeeNr, directInvoiceFee.Description, directInvoiceFee.PeriodFrom, directInvoiceFee.PeriodTo, void 0)));
                                return singleton.Bind(props.CreateDirectInvoiceFn(createDirectInvoiceDTO), (_arg_5) => {
                                    const createDirectInvoiceResult = _arg_5;
                                    return singleton.Combine((createDirectInvoiceResult.tag === 0) ? ((saveItems[1](ofArray([[saveOneTimeFeeMsg, new SaveStatus(2)], [createDirectInvoiceMsg, new SaveStatus(2)], [createInvoiceNoteMsg, new SaveStatus(1)]])), singleton.Bind(props.CreateInvoiceNote(new CreateInvoiceNoteDTO(noteState[0])), (_arg_6) => {
                                        const createInvoiceNoteResult_1 = _arg_6;
                                        if (createInvoiceNoteResult_1.tag === 0) {
                                            saveItems[1](ofArray([[saveOneTimeFeeMsg, new SaveStatus(2)], [createDirectInvoiceMsg, new SaveStatus(2)], [createInvoiceNoteMsg, new SaveStatus(2)]]));
                                            return singleton.Zero();
                                        }
                                        else {
                                            saveItems[1](ofArray([[saveOneTimeFeeMsg, new SaveStatus(2)], [createDirectInvoiceMsg, new SaveStatus(2)], [createInvoiceNoteMsg, new SaveStatus(3, createInvoiceNoteResult_1.fields[0])]]));
                                            return singleton.Zero();
                                        }
                                    }))) : ((saveItems[1](ofArray([[saveOneTimeFeeMsg, new SaveStatus(2)], [createDirectInvoiceMsg, new SaveStatus(3, createDirectInvoiceResult.fields[0])], [createInvoiceNoteMsg, new SaveStatus(0)]])), singleton.Zero())), singleton.Delay(() => {
                                        props.ReloadPendingDirectInvoices();
                                        return singleton.Zero();
                                    }));
                                });
                            }
                            else {
                                saveItems[1](ofArray([[saveOneTimeFeeMsg, new SaveStatus(2)], [createDirectInvoiceMsg, new SaveStatus(3, "Could not find fee just created, this is probably a programming error. Contact support.")], [createInvoiceNoteMsg, new SaveStatus(0)]]));
                                return singleton.Zero();
                            }
                        }
                        else {
                            saveItems[1](ofArray([[saveOneTimeFeeMsg, new SaveStatus(2)], [createDirectInvoiceMsg, new SaveStatus(3, directInvoiceInfoResult.fields[0])], [createInvoiceNoteMsg, new SaveStatus(0)]]));
                            return singleton.Zero();
                        }
                    });
                }
                else {
                    saveItems[1](ofArray([[saveOneTimeFeeMsg, new SaveStatus(3, createFeeResult_1.fields[0])], [createDirectInvoiceMsg, new SaveStatus(0)], [createInvoiceNoteMsg, new SaveStatus(0)]]));
                    return singleton.Zero();
                }
            }));
        }
        else {
            saveItems[1](ofArray([[saveOneTimeFeeMsg, new SaveStatus(1)], [createInvoiceNoteMsg, new SaveStatus(0)]]));
            return singleton.Delay(() => singleton.Bind(props.CreateInvoiceeFeeFn(createFeeDTO), (_arg_1) => {
                const createFeeResult = _arg_1;
                if (createFeeResult.tag === 0) {
                    saveItems[1](ofArray([[saveOneTimeFeeMsg, new SaveStatus(2)], [createInvoiceNoteMsg, new SaveStatus(1)]]));
                    return singleton.Bind(props.CreateInvoiceNote(new CreateInvoiceNoteDTO(noteState[0])), (_arg_2) => {
                        const createInvoiceNoteResult = _arg_2;
                        if (createInvoiceNoteResult.tag === 0) {
                            saveItems[1](ofArray([[saveOneTimeFeeMsg, new SaveStatus(2)], [createInvoiceNoteMsg, new SaveStatus(2)]]));
                            return singleton.Zero();
                        }
                        else {
                            saveItems[1](ofArray([[saveOneTimeFeeMsg, new SaveStatus(2)], [createInvoiceNoteMsg, new SaveStatus(3, createInvoiceNoteResult.fields[0])]]));
                            return singleton.Zero();
                        }
                    });
                }
                else {
                    saveItems[1](ofArray([[saveOneTimeFeeMsg, new SaveStatus(3, createFeeResult.fields[0])], [createInvoiceNoteMsg, new SaveStatus(0)]]));
                    return singleton.Zero();
                }
            }));
        }
    };
    let radioButtonsHtml;
    const children = [inputRadio((inputRecord = RadioInput_get_getDefault(), (DisplayString = getTranslation("CustomerContract.Invoicee.Invoices.CreditNextInvoice"), (IsChecked = equals_1(actionChoiceState[0], new ActionChoice(1)), new RadioInput("credit-modal-next-invoice-radio", "credit-modal-radio", (e_2) => {
        const arg_20 = ActionChoice_get_FromString()(Browser_Types_Event__Event_get_Value(e_2));
        actionChoiceState[1](arg_20);
    }, ActionChoice_get_ToString()(new ActionChoice(1)), DisplayString, IsChecked, inputRecord.Disabled))))), inputRadio((inputRecord_1 = RadioInput_get_getDefault(), (DisplayString_1 = getTranslation("CustomerContract.Invoicee.Invoices.CreditViaDirectInvoice"), (IsChecked_1 = equals_1(actionChoiceState[0], new ActionChoice(0)), new RadioInput("credit-modal-direct-invoice-radio", "credit-modal-radio", (e_3) => {
        const arg_21 = ActionChoice_get_FromString()(Browser_Types_Event__Event_get_Value(e_3));
        actionChoiceState[1](arg_21);
    }, ActionChoice_get_ToString()(new ActionChoice(0)), DisplayString_1, IsChecked_1, inputRecord_1.Disabled))))), inputRadio((inputRecord_2 = RadioInput_get_getDefault(), (DisplayString_2 = getTranslation("CustomerContract.Invoicee.Invoices.CreditVoid"), (IsChecked_2 = equals_1(actionChoiceState[0], new ActionChoice(2)), new RadioInput("credit-modal-void-radio", "credit-modal-radio", (e_4) => {
        const arg_22 = ActionChoice_get_FromString()(Browser_Types_Event__Event_get_Value(e_4));
        actionChoiceState[1](arg_22);
    }, ActionChoice_get_ToString()(new ActionChoice(2)), DisplayString_2, IsChecked_2, inputRecord_2.Disabled))))), inputRadio((inputRecord_3 = RadioInput_get_getDefault(), (DisplayString_3 = getTranslation("CustomerContract.Invoicee.Invoices.CreditCustomerLoss"), (IsChecked_3 = equals_1(actionChoiceState[0], new ActionChoice(3)), new RadioInput("credit-modal-customer-loss-radio", "credit-modal-radio", (e_5) => {
        const arg_23 = ActionChoice_get_FromString()(Browser_Types_Event__Event_get_Value(e_5));
        actionChoiceState[1](arg_23);
    }, ActionChoice_get_ToString()(new ActionChoice(3)), DisplayString_3, IsChecked_3, inputRecord_3.Disabled)))))];
    radioButtonsHtml = react.createElement("div", {}, ...children);
    let infoBoxHtml;
    const textStr = unEscape((matchValue_10 = (actionChoiceState[0]), (matchValue_10.tag === 0) ? getTranslation("CustomerContract.Invoicee.Invoices.CreditViaDirectInvoiceInfoText") : ((matchValue_10.tag === 2) ? getTranslation("CustomerContract.Invoicee.Invoices.CreditVoidInfoText") : ((matchValue_10.tag === 3) ? getTranslation("CustomerContract.Invoicee.Invoices.CreditCustomerLossInfoText") : getTranslation("CustomerContract.Invoicee.Invoices.CreditNextInvoiceInfoText")))));
    infoBoxHtml = customMessage(react.createElement("div", {
        className: "credit-modal__info-box",
    }, textStr), new MessageKind(0));
    let feeDescriptionHtml;
    const matchValue_11 = actionChoiceState[0];
    switch (matchValue_11.tag) {
        case 0: {
            feeDescriptionHtml = render_1()((inputRecord_4 = TextProps$1_GetDefault(), (LabelText = getTranslation("CustomerContract.Invoicee.Invoices.CreditFeeText"), new TextProps$1(feeDescriptionState[0], inputRecord_4.Type, inputRecord_4.Classes, (e_6) => {
                const arg_24 = Browser_Types_Event__Event_get_Value(e_6);
                feeDescriptionState[1](arg_24);
            }, inputRecord_4.Disabled, LabelText, "credit-modal-fee-description-input", (value_7) => lengthLTE(getTranslation, 500, new InputType(2), value_7), inputRecord_4.DynamicWidth, inputRecord_4.HTMLProps, inputRecord_4.OnBlur, inputRecord_4.OnFocus, inputRecord_4.AutoComplete, inputRecord_4.Name))));
            break;
        }
        case 2:
        case 3: {
            feeDescriptionHtml = react.createElement(react.Fragment, {});
            break;
        }
        default: {
            feeDescriptionHtml = render_1()((inputRecord_4 = TextProps$1_GetDefault(), (LabelText = getTranslation("CustomerContract.Invoicee.Invoices.CreditFeeText"), new TextProps$1(feeDescriptionState[0], inputRecord_4.Type, inputRecord_4.Classes, (e_6) => {
                const arg_24 = Browser_Types_Event__Event_get_Value(e_6);
                feeDescriptionState[1](arg_24);
            }, inputRecord_4.Disabled, LabelText, "credit-modal-fee-description-input", (value_7) => lengthLTE(getTranslation, 500, new InputType(2), value_7), inputRecord_4.DynamicWidth, inputRecord_4.HTMLProps, inputRecord_4.OnBlur, inputRecord_4.OnFocus, inputRecord_4.AutoComplete, inputRecord_4.Name))));
        }
    }
    let amountDetailsHtml;
    let amountStr;
    const arg_26 = separateByThousands(decimalToTwoDecimals(amount));
    const arg_25 = getTranslation("CustomerContract.Invoicee.Invoices.InvoiceAmount");
    amountStr = toText(printf("%s: %s"))(arg_25)(arg_26);
    let remainingAmountTranslation;
    const arg_27 = getTranslation("CustomerContract.Invoicee.Invoices.RemainingAmount");
    remainingAmountTranslation = toText(printf("%s: %s"))(arg_27)(remainingAmountStr);
    const props_10 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "mt-2", "mb-2"])))];
    const children_9 = [react.createElement("div", {}, amountStr), (props_8 = [new HTMLAttr(65, stackClasses(singleton_1("ml-4")))], react.createElement("div", keyValueList(props_8, 1), remainingAmountTranslation))];
    amountDetailsHtml = react.createElement("div", keyValueList(props_10, 1), ...children_9);
    const isLessThanAmount = (userAmountStr) => {
        if (compare(amountPrepareForParse(userAmountStr), amount) > 0) {
            return new FSharpResult$2(1, getTranslation("CustomerContract.Invoicee.Invoices.AmountInvalid"));
        }
        else {
            return new FSharpResult$2(0, userAmountStr);
        }
    };
    let amountInputHtml;
    const children_11 = [render_1()((inputRecord_5 = TextProps$1_GetDefault(), new TextProps$1((amountState[0]).AmountExclVat, inputRecord_5.Type, inputRecord_5.Classes, (e_7) => {
        const arg_29 = new AmountMsg(1, Browser_Types_Event__Event_get_Value(e_7));
        amountState[1](arg_29);
    }, inputRecord_5.Disabled, (arg_31 = getTranslation("Common.ExclVat"), (arg_30 = getTranslation("CustomerContract.Invoicee.Invoices.AmountToCredit"), toText(printf("%s (%s)"))(arg_30)(arg_31))), "credit-modal-amount-excl-vat-input", (str_9) => Result_Bind(isLessThanAmount, isOnlyNumberWithPossibleDecimals(getTranslation, str_9)), inputRecord_5.DynamicWidth, inputRecord_5.HTMLProps, inputRecord_5.OnBlur, inputRecord_5.OnFocus, inputRecord_5.AutoComplete, inputRecord_5.Name))), render_1()((inputRecord_6 = TextProps$1_GetDefault(), new TextProps$1((amountState[0]).AmountInclVat, inputRecord_6.Type, inputRecord_6.Classes, (e_8) => {
        const arg_32 = new AmountMsg(0, Browser_Types_Event__Event_get_Value(e_8));
        amountState[1](arg_32);
    }, inputRecord_6.Disabled, (arg_34 = getTranslation("Common.InclVat"), (arg_33 = getTranslation("CustomerContract.Invoicee.Invoices.AmountToCredit"), toText(printf("%s (%s)"))(arg_33)(arg_34))), "credit-modal-amount-incl-vat-input", (str_11) => Result_Bind(isLessThanAmount, isOnlyNumberWithPossibleDecimals(getTranslation, str_11)), inputRecord_6.DynamicWidth, inputRecord_6.HTMLProps, inputRecord_6.OnBlur, inputRecord_6.OnFocus, inputRecord_6.AutoComplete, inputRecord_6.Name))), selectOption((inputRecord_7 = SelectOption_get_getDefault(), new SelectOption(new ValueProp_1(0, (arg_35 = (amountState[0]).Vat, toText(printf("%M"))(arg_35)), (e_9) => {
        const arg_36 = new AmountMsg(2, Browser_Types_Event__Event_get_Value(e_9));
        amountState[1](arg_36);
    }), "credit-modal-vat-select", map((x_11) => [toText(printf("%M"))(x_11), toText(printf("%M%%"))(x_11)], vatRates), inputRecord_7.Classes, getTranslation("Containers.FeesTable.Vat"), false, inputRecord_7.HTMLProps)))];
    amountInputHtml = react.createElement("div", {
        className: "credit-modal__container",
    }, ...children_11);
    const noteValidationFn = (value_8) => Result_Bind((str_14) => isNotNullOrWhitespace(getTranslation, str_14), lengthLTE(getTranslation, 60, new InputType(2), value_8));
    const noteHtml = render_1()((inputRecord_8 = TextProps$1_GetDefault(), (LabelText_4 = getTranslation("CustomerContract.Invoicee.Invoices.InternalInvoiceNote"), new TextProps$1(noteState[0], inputRecord_8.Type, inputRecord_8.Classes, (e_10) => {
        const arg_39 = Browser_Types_Event__Event_get_Value(e_10);
        noteState[1](arg_39);
    }, inputRecord_8.Disabled, LabelText_4, "credit-modal-note-input", noteValidationFn, inputRecord_8.DynamicWidth, inputRecord_8.HTMLProps, inputRecord_8.OnBlur, inputRecord_8.OnFocus, inputRecord_8.AutoComplete, inputRecord_8.Name))));
    let errorMessageHtml;
    const matchValue_12 = errorMessageState[0];
    if (matchValue_12 != null) {
        const msg_9 = matchValue_12;
        const children_14 = [error(msg_9.split(""))];
        errorMessageHtml = react.createElement("div", {
            className: "mt-3",
        }, ...children_14);
    }
    else {
        errorMessageHtml = react.createElement(react.Fragment, {});
    }
    let bodyHtml;
    const children_18 = [radioButtonsHtml, infoBoxHtml, amountDetailsHtml, feeDescriptionHtml, amountInputHtml, (props_17 = [new HTMLAttr(65, stackClasses(ofArray(["mt-2", "mb-2"])))], react.createElement("div", keyValueList(props_17, 1), noteHtml)), errorMessageHtml];
    bodyHtml = react.createElement("div", {
        className: "credit-modal",
        id: "credit-modal",
    }, ...children_18);
    let cancelButtonProps;
    const inputRecord_9 = ButtonProps_get_getDefault();
    cancelButtonProps = (new ButtonProps(getTranslation("Common.Cancel"), inputRecord_9.Content, (_arg_9) => {
        props.CloseModalFn();
    }, inputRecord_9.Disabled, "credit-modal-cancel-btn", inputRecord_9.SaveStatus, inputRecord_9.HTMLProps, inputRecord_9.ExtraClasses, inputRecord_9.Icon));
    let acceptButtonProps;
    let hasValidAmount;
    const matchValue_13 = [compare(amount, fromParts(0, 0, 0, false, 1)) < 0, actionChoiceState[0]];
    let pattern_matching_result;
    if (matchValue_13[0]) {
        if (matchValue_13[1].tag === 2) {
            pattern_matching_result = 0;
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            hasValidAmount = (compare(amountPrepareForParse((amountState[0]).AmountExclVat), fromParts(0, 0, 0, false, 0)) < 0);
            break;
        }
        case 1: {
            hasValidAmount = (compare(amountPrepareForParse((amountState[0]).AmountExclVat), fromParts(0, 0, 0, false, 0)) > 0);
            break;
        }
    }
    const inputRecord_10 = ButtonProps_get_getDefault();
    const Disabled_1 = (!hasValidAmount) ? true : (!Result_toBool(noteValidationFn(noteState[0])));
    acceptButtonProps = (new ButtonProps(getTranslation("Common.Confirm"), inputRecord_10.Content, (_arg_11) => {
        let arg_14, a_2, dto;
        const matchValue_6 = actionChoiceState[0];
        switch (matchValue_6.tag) {
            case 3: {
                let transactionTypeCodeOpt;
                const matchValue_7 = actionChoiceState[0];
                switch (matchValue_7.tag) {
                    case 3: {
                        transactionTypeCodeOpt = 31;
                        break;
                    }
                    case 2: {
                        transactionTypeCodeOpt = 34;
                        break;
                    }
                    default: {
                        const arg_16 = loge((arg_14 = toString(matchValue_7), toText(printf("No transaction type for %s"))(arg_14)));
                        errorMessageState[1](arg_16);
                        transactionTypeCodeOpt = (void 0);
                    }
                }
                if (transactionTypeCodeOpt != null) {
                    const transactionTypeCode = transactionTypeCodeOpt | 0;
                    startImmediate((a_2 = ((dto = (new CreateNewPaymentApiDTO(noteState[0], amountPrepareForParse((amountState[0]).AmountInclVat), transactionTypeCode)), (saveItems[1](singleton_1([getTranslation("Common.Saving"), new SaveStatus(1)])), singleton.Delay(() => singleton.Bind(props.CreateNewPaymentFn(dto), (_arg) => {
                        let msg_1, saveStatus, jsonStartIndex, matchValue_4, str_3, pos1, pos2, matchValue_3, jsonStr;
                        const result = _arg;
                        return singleton.Combine((result.tag === 1) ? ((msg_1 = result.fields[0], ((saveStatus = (new SaveStatus(3, ((jsonStartIndex = (msg_1.indexOf("\\\"{") | 0), (jsonStartIndex === -1) ? "" : substring(msg_1, 0, jsonStartIndex))) + ((matchValue_4 = ((str_3 = msg_1, (pos1 = (str_3.indexOf("\\\"{") | 0), (pos2 = (str_3.lastIndexOf("}\\\"") | 0), (matchValue_3 = [pos1 !== -1, pos2 !== -1], matchValue_3[0] ? (matchValue_3[1] ? ((jsonStr = replace(substring(str_3, pos1 + 2, (pos2 - pos1) - 1), "\\", ""), (() => {
                            try {
                                return fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(S5PaymentError$reflection(), new CaseStrategy(0), void 0)), jsonStr);
                            }
                            catch (e) {
                                return new FSharpResult$2(1, loge_1(toText(printf("%A"))(e)));
                            }
                        })())) : (new FSharpResult$2(1, "[Utils.parseEscapedJsonInString] Can\u0027t find escaped JSON string."))) : (new FSharpResult$2(1, "[Utils.parseEscapedJsonInString] Can\u0027t find escaped JSON string."))))))), (matchValue_4.tag === 1) ? ((logwi(matchValue_4.fields[0]), msg_1)) : join("; ", choose((x_2) => x_2, map((e_1) => e_1.Description, matchValue_4.fields[0].Errors))))))), saveItems[1](singleton_1([getTranslation("Common.Saving"), saveStatus]))), singleton.Zero()))) : ((saveItems[1](singleton_1([getTranslation("Common.Saving"), new SaveStatus(2)])), singleton.Zero())), singleton.Delay(() => singleton.Return(result)));
                    }))))), singleton.Delay(() => singleton.Bind(a_2, (_arg_7) => singleton.Return(void _arg_7)))));
                }
                break;
            }
            case 1:
            case 0: {
                const matchValue_8 = [(amountState[0]).AmountExclVat, (amountState[0]).Vat];
                const createFeeDTO_1 = new CreateFeeDTOV2(void 0, void 0, void 0, DateOnlyExtensions_fromDateTime(now_1()), PeriodModule_toString(new Period(0)), op_UnaryNegation(abs(amountPrepareForParse(matchValue_8[0]))), matchValue_8[1], feeDescriptionState[0], props.AccountNoCrediting, 1, 0, void 0, void 0, empty(), 1);
                const matchValue_9 = actionChoiceState[0];
                switch (matchValue_9.tag) {
                    case 1: {
                        startImmediate(createOneTimeFeeAndMaybeDirectInvoice(createFeeDTO_1, false));
                        break;
                    }
                    case 0: {
                        startImmediate(createOneTimeFeeAndMaybeDirectInvoice(createFeeDTO_1, true));
                        break;
                    }
                    default: {
                        throw (new Error("Unrecognized ActionChoice (this should not happen)."));
                    }
                }
                break;
            }
            default: {
                let transactionTypeCodeOpt;
                const matchValue_7 = actionChoiceState[0];
                switch (matchValue_7.tag) {
                    case 3: {
                        transactionTypeCodeOpt = 31;
                        break;
                    }
                    case 2: {
                        transactionTypeCodeOpt = 34;
                        break;
                    }
                    default: {
                        const arg_16 = loge((arg_14 = toString(matchValue_7), toText(printf("No transaction type for %s"))(arg_14)));
                        errorMessageState[1](arg_16);
                        transactionTypeCodeOpt = (void 0);
                    }
                }
                if (transactionTypeCodeOpt != null) {
                    const transactionTypeCode = transactionTypeCodeOpt | 0;
                    startImmediate((a_2 = ((dto = (new CreateNewPaymentApiDTO(noteState[0], amountPrepareForParse((amountState[0]).AmountInclVat), transactionTypeCode)), (saveItems[1](singleton_1([getTranslation("Common.Saving"), new SaveStatus(1)])), singleton.Delay(() => singleton.Bind(props.CreateNewPaymentFn(dto), (_arg) => {
                        let msg_1, saveStatus, jsonStartIndex, matchValue_4, str_3, pos1, pos2, matchValue_3, jsonStr;
                        const result = _arg;
                        return singleton.Combine((result.tag === 1) ? ((msg_1 = result.fields[0], ((saveStatus = (new SaveStatus(3, ((jsonStartIndex = (msg_1.indexOf("\\\"{") | 0), (jsonStartIndex === -1) ? "" : substring(msg_1, 0, jsonStartIndex))) + ((matchValue_4 = ((str_3 = msg_1, (pos1 = (str_3.indexOf("\\\"{") | 0), (pos2 = (str_3.lastIndexOf("}\\\"") | 0), (matchValue_3 = [pos1 !== -1, pos2 !== -1], matchValue_3[0] ? (matchValue_3[1] ? ((jsonStr = replace(substring(str_3, pos1 + 2, (pos2 - pos1) - 1), "\\", ""), (() => {
                            try {
                                return fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(S5PaymentError$reflection(), new CaseStrategy(0), void 0)), jsonStr);
                            }
                            catch (e) {
                                return new FSharpResult$2(1, loge_1(toText(printf("%A"))(e)));
                            }
                        })())) : (new FSharpResult$2(1, "[Utils.parseEscapedJsonInString] Can\u0027t find escaped JSON string."))) : (new FSharpResult$2(1, "[Utils.parseEscapedJsonInString] Can\u0027t find escaped JSON string."))))))), (matchValue_4.tag === 1) ? ((logwi(matchValue_4.fields[0]), msg_1)) : join("; ", choose((x_2) => x_2, map((e_1) => e_1.Description, matchValue_4.fields[0].Errors))))))), saveItems[1](singleton_1([getTranslation("Common.Saving"), saveStatus]))), singleton.Zero()))) : ((saveItems[1](singleton_1([getTranslation("Common.Saving"), new SaveStatus(2)])), singleton.Zero())), singleton.Delay(() => singleton.Return(result)));
                    }))))), singleton.Delay(() => singleton.Bind(a_2, (_arg_7) => singleton.Return(void _arg_7)))));
                }
            }
        }
    }, Disabled_1, "credit-modal-confirm-btn", inputRecord_10.SaveStatus, inputRecord_10.HTMLProps, inputRecord_10.ExtraClasses, inputRecord_10.Icon));
    return renderAsModalThenSaveState(true, new ModalSize(2), isEmpty(saveItems[0]) ? getTranslation("CustomerContract.Invoicee.Invoices.CreditHeading") : ((matchValue_15 = (actionChoiceState[0]), (matchValue_15.tag === 0) ? getTranslation("CustomerContract.Invoicee.Invoices.CreditViaDirectInvoice") : ((matchValue_15.tag === 2) ? getTranslation("CustomerContract.Invoicee.Invoices.CreditVoid") : ((matchValue_15.tag === 3) ? getTranslation("CustomerContract.Invoicee.Invoices.CreditCustomerLoss") : getTranslation("CustomerContract.Invoicee.Invoices.CreditNextInvoice"))))), bodyHtml, cancelButtonProps, acceptButtonProps, getTranslation("Common.Confirm"), (_arg_12) => {
        props.CloseModalFn();
    }, saveItems[0]);
}, void 0, uncurry(2, void 0), void 0, "renderCreditModal", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Invoices\\Credit.fs", 662);

